import React from "react";

export const esmdRoundSubmittedCellRender = (cellData: any) => {
  const seqNo = Number(cellData.value);
  const isDeleted = cellData.data?.isRoundDeleted;
  return (
    <span>
      {seqNo > 0 ? seqNo : ""}
      {isDeleted && (
        <i
          className="dx-icon-warning"
          title="This round was deleted"
          style={{ marginLeft: 4, color: "orange" }}
        />
      )}
    </span>
  );
};
